import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listLiveStreams } from '../../services/liveStreamApi/liveStreamApi';
import type { LiveStream } from '../../services/liveStreamApi/liveStreamApi';
import styles from './LiveStreamList.module.css';

const STATUS_LABELS: Record<LiveStream['status'], string> = {
  scheduled: '配信予定',
  live: 'LIVE',
  ended: '終了',
  error: 'エラー',
};

const LIVE_STREAM_POLL_INTERVAL_MS = 10_000;

export default function LiveStreamList() {
  const [streams, setStreams] = useState<LiveStream[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchStreams = async () => {
      try {
        const nextStreams = await listLiveStreams();
        if (!isMounted) return;
        setStreams(nextStreams);
        setError(null);
      } catch {
        if (!isMounted) return;
        setError('ライブ配信一覧の取得に失敗しました');
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    void fetchStreams();
    const timer = setInterval(() => {
      // バックグラウンドタブではポーリングを休止する
      if (document.hidden) return;
      void fetchStreams();
    }, LIVE_STREAM_POLL_INTERVAL_MS);

    return () => {
      isMounted = false;
      clearInterval(timer);
    };
  }, []);

  if (loading) return <div className={styles['live-stream-list-page']}>読み込み中...</div>;
  if (error) return <div className={styles['live-stream-list-page']}>{error}</div>;

  return (
    <div className={styles['live-stream-list-page']}>
      <div className={styles['live-stream-list-page__header']}>
        <h1 className={styles['live-stream-list-page__title']}>ライブ配信</h1>
      </div>

      {streams.length === 0 ? (
        <p className={styles['live-stream-list-page__empty']}>ライブ配信はありません</p>
      ) : (
        <div className={styles['live-stream-list-page__grid']}>
          {streams.map((s) => (
            <Link
              key={s.id}
              to={`/live-streams/${s.id}`}
              className={styles['live-stream-card']}
            >
              <div className={styles['live-stream-card__title']}>{s.title}</div>
              <div className={styles['live-stream-card__meta']}>
                {s.started_at
                  ? new Date(s.started_at).toLocaleString('ja-JP')
                  : '未開始'}
              </div>
              <span
                className={`${styles['live-stream-card__status']} ${styles[`live-stream-card__status--${s.status}`]}`}
              >
                {STATUS_LABELS[s.status]}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
